import opal from '../assets/opal.png';

function Loader() {

  return (<div className="flex w-full h-full flex-col justify-center items-center">
    <div className="flex">
      <img src={opal} className="rotating-loading-gem" alt="loader" />
    </div>
  </div>)
}

export default Loader
